import React from 'react'
import { CFooter } from '@coreui/react'
import moment from 'moment'

const AppFooter = () => {
  return (
    <CFooter className={'mt-4'}>
      <div>
        <a href="https://ottdock.com/" target="_blank" rel="noopener noreferrer">
          OTTDock
        </a>
        <span className="ms-1">&copy; {moment().year()} OTTDock.</span>
      </div>
      <div className="ms-auto">
        {/* <span className="me-1">Powered by</span>
        <a href="https://coreui.io/react" target="_blank" rel="noopener noreferrer">
          CoreUI for React
        </a> */}
      </div>
    </CFooter>
  )
}

export default React.memo(AppFooter)
